import { render, staticRenderFns } from "./OrderStatusActions.vue?vue&type=template&id=613273e9&"
import script from "./OrderStatusActions.vue?vue&type=script&lang=js&"
export * from "./OrderStatusActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports